import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=4f7763e8&scoped=true&"
import script from "./faq.vue?vue&type=script&lang=ts&"
export * from "./faq.vue?vue&type=script&lang=ts&"
import style0 from "@/styles/deduction.less?vue&type=style&index=0&lang=less&"
import style1 from "./faq.vue?vue&type=style&index=1&id=4f7763e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7763e8",
  null
  
)

export default component.exports